export const skin_index = [
  'OSPW',
  'OSPT',
  'OSNW',
  'OSNT',
  'ORPW',
  'ORPT',
  'ORNW',
  'ORNT',
  'DSPW',
  'DSPT',
  'DSNW',
  'DSNT',
  'DRPW',
  'DRPT',
  'DRNW',
  'DRNT'
];
